// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';
import { paginationQuerySchema } from '../../utils/listQuery.schema';
import { extensionEventSchema } from '../models/event.schema';

export const hooksListQuerySchema = z
  .object({
    id: z.union([idSchema, z.array(idSchema)]),
    name: z.string(),
    search: z.string(),
    type: z.string(),
    queue: z.number(),
    active: z.boolean(),
    configAppUrl: z.string(),
    events: extensionEventSchema,
  })
  .partial()
  .and(paginationQuerySchema);
